module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "energie-c.57083656.png";